import { API, Space, AssetView } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  spaceId: Space["id"];
  viewId: AssetView["id"];
};

const [useDeleteView, deleteView] = createAsyncAction("views/delete", async ({ viewId }: Args) => {
  const res = await API.call<{ view: string }>({
    endpoint: `/views/${viewId}`,
    method: "DELETE",
  });
  return { ...res, result: res.result.view };
});

export default useDeleteView;
export { deleteView };
